export default __webpack_public_path__ + "static/media/day-setup@2x.66a9380e.webp";